// biome-ignore lint/performance/noBarrelFile: We should eventually kill these refs.
export {
  isImageToText,
  isPreviewModel,
  isSpeechToText,
  isTextToSpeech,
  isTextToText,
  modelDoesNotSupportSystemPromptIfImageInMessages,
  modelSupportsImageInMessages,
} from "../data/hardcoded-shared-settings";

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const thinkingRegex = /[\s\S]*<think>([\s\S]*?)<\/think>/i;

export function splitThinkingContent(text: string): [string, string] {
  // Regular expression to match the <thinking> content
  const thinkingMatch = text.match(thinkingRegex);

  let thinkingText = "";
  let outsideText = text;

  if (thinkingMatch) {
    // Extract the thinking text
    thinkingText = thinkingMatch[1]?.trim() || "";

    // Remove the thinking section from the outside text
    outsideText = text.replace(thinkingMatch[0], "").trim();
  } else {
    // Handle case where <thinking> is open but not closed
    const openThinkingIndex = text.toLowerCase().indexOf("<think>");

    if (openThinkingIndex !== -1) {
      thinkingText = text.slice(openThinkingIndex + 8).trim();
      outsideText = text.slice(0, openThinkingIndex).trim();
    }
  }

  return [thinkingText, outsideText];
}

// Basic RTL language detection based on character codes
export const isRtlText = (text: string) => {
  if (typeof text !== "string") {
    return;
  }
  const rtlChars =
    /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g;
  const rtlDirCharsCount = (text.match(rtlChars) || []).length;

  // This is a very basic check and might consider a text as RTL even if it contains a mix of RTL and LTR characters
  return rtlDirCharsCount > text.length - rtlDirCharsCount;
};

export function isSpecialParamsModel(model: string) {
  return model.includes("deepseek") || model.includes("qwen");
}

export function isCompoundSystem(model: string): boolean {
  return (
    model.toLowerCase().includes("compound") &&
    !model.toLowerCase().includes("oss")
  );
}

/**
 * Filters out <tool>, </tool>, <output>, and </output> blocks from reasoning text.
 * Also handles partial content where a tag starts but doesn't close.
 * @param text The input text to filter
 * @returns The filtered text with tool and output blocks removed
 */
export function filterToolOutputBlocks(text: string): string {
  if (!text) {
    return "";
  }

  // Replace complete tool/output blocks with nothing
  let filteredText = text;

  // Remove complete <tool>...</tool> blocks
  filteredText = filteredText.replace(/<tool>[\s\S]*?<\/tool>/g, "");

  // Remove complete <output>...</output> blocks
  filteredText = filteredText.replace(/<output>[\s\S]*?<\/output>/g, "");

  // Handle partial tags - remove everything after <tool> or <output> if not closed
  const toolIndex = filteredText.indexOf("<tool>");
  if (toolIndex !== -1) {
    filteredText = filteredText.substring(0, toolIndex);
  }

  const outputIndex = filteredText.indexOf("<output>");
  if (outputIndex !== -1) {
    filteredText = filteredText.substring(0, outputIndex);
  }
  return filteredText.trim();
}
